import React, {useContext, useState} from 'react';
import styles from "./Modal.module.css";
import LoadingButton from "../Button/LoadingButton";
import {processPaylinksFile, RefreshContext} from "../../services";
import innerStyles from "./ModalUploadSmsFileContainer.module.css";
import Checkbox from "../Checkbox/Checkbox";

type Props = {
    onClose: () => void;
    paylinksFileId: number;
    defaultMailWhenComplete: boolean;
};

const ModalProcessPaylinksFileContainer = ({
                                         onClose,
                                         paylinksFileId,
                                         defaultMailWhenComplete,
                                     }: Props) => {
    const {refresh} = useContext(RefreshContext);
    const [errorMessage, setErrorMessage] = useState('');
    const [mailWhenComplete, setMailWhenComplete] = useState<boolean>(defaultMailWhenComplete);

    const handleSubmit = async () => {
        try {
            setErrorMessage('');
            await processPaylinksFile(paylinksFileId, mailWhenComplete);
            onClose();
            refresh(`paylinksFile-${paylinksFileId}`);
        } catch (error) {
            setErrorMessage(error.message || 'An error occurred. Refresh this page or try again later.');
        }
    };

    return (
        <div className={styles.modal}>
            <div className={styles.title}>Are you sure you want to start processing this paylinks file?</div>
            <div className={styles.body}>
                <div className={innerStyles.spacer}>This will create paylinks.</div>
                <div className={innerStyles.notificationWrapper}>
                    <div className={innerStyles.notificationCheckboxWrapper} onClick={() => setMailWhenComplete(mailWhenComplete => !mailWhenComplete)}>
                        <Checkbox isChecked={mailWhenComplete}/>
                    </div>
                    <div className={innerStyles.notificationTextWrapper}>Receive an e-mail once the file is processed</div>
                </div>
            </div>

            {errorMessage && (
                <div className={styles.errorWrapper}>
                    {errorMessage}
                </div>
            )}
            <LoadingButton label="Process file" onClick={handleSubmit}/>
        </div>
    );
};

export default ModalProcessPaylinksFileContainer;
